import React, { Fragment } from "react";
import ImagenMain from "./ImagenMain";
import Footer from "./Footer";
import HeroPhoto from "./HeroPhoto";

/**
 * Home (Main)
 * Objetivo: look 2026 sobrio/corporate para Responsable IT / .NET Senior.
 * Mantiene tu estructura (ImagenMain + Footer) y tus clases CSS.
 * Sin Header / Sin menú. Foto pequeña en el hero.
 */
const Main = () => {
  const stack = [
    ".NET Framework",
    "C#",
    "ASP.NET WebForms",
    "SQL Server",
    "APIs REST",
    "Azure",
    "IIS",
    "Telerik UI",
    "Power BI",
    "JavaScript",
    "Selenium",
    "Xamarin Android",
  ];

  return (
    <Fragment>
     
      <main className="cvMain">
        {/* HERO */}
        <section className="cvHero cvHero2026">
          <div className="cvContainer cvHeroGrid">
            <div className="cvHeroLeft">
              <p className="cvKicker">Responsable IT / .NET Senior</p>
              <h1 className="cvTitle">Jose Antonio Navas Ruiz</h1>
              <p className="cvSubtitle">
                .NET · SQL Server · ASP.NET WebForms · APIs REST · Azure/IIS · Telerik
              </p>

              <div className="cvCtas">
                <a className="cvBtnPrimary" href="/cv.pdf" target="_blank" rel="noreferrer">
                  Descargar CV (PDF)
                </a>
                <a className="cvBtnGhost" href="mailto:koeman1976@hotmail.com">
                  Email
                </a>
                <a className="cvBtnGhost" href="https://www.linkedin.com/in/jose-antonio-navas-ruiz-25694859/" target="_blank" rel="noreferrer">
                  LinkedIn
                </a>
              </div>

              <div className="cvMeta">
                <span className="cvMetaItem">Madrid</span>
                <span className="cvMetaDot" aria-hidden="true" />
                <span className="cvMetaItem">Operación · Arquitectura · Integración</span>
              </div>
            </div>

            {/* Foto pequeña */}
            <aside className="cvHeroRight" aria-label="Fotografía">
              <HeroPhoto />
            </aside>
          </div>
        </section>

        {/* LO QUE APORTO */}
        <section className="cvSection">
          <div className="cvContainer">
            <div className="cvSectionHead">
              <h2 className="cvH2">Lo que aporto</h2>
              <p className="cvMuted">
                Perfil híbrido: gestión y ejecución. Enfocado a estabilidad, escalabilidad y entrega.
              </p>
            </div>

            <div className="cvGrid3">
              <article className="cvCard cvFeature">
                <h3 className="cvH3">Gestión IT y continuidad de servicio</h3>
                <p className="cvP">
                  Responsable de la operación diaria y evolución de plataformas IT críticas, equilibrando fiabilidad, coste y necesidades de negocio.
                </p>
                <ul className="cvBullets">
                  <li>SLA, ITSM y gestión de incidencias en producción</li>
                  <li>Coordinación técnica y toma de decisiones bajo impacto</li>
                  <li>Planificación técnica y priorización</li>
                  <li>Mejora continua y control del riesgo</li>
                </ul>
              </article>

              <article className="cvCard cvFeature">
                <h3 className="cvH3">Arquitectura .NET pragmática</h3>
                <p className="cvP">
                  Evolución de legacy crítico sin romper operación: performance, deuda técnica y calidad.
                </p>
                <ul className="cvBullets">
                  <li>APIs, integración y automatización</li>
                  <li>Patrones, refactor incremental</li>
                  <li>Despliegues controlados</li>
                </ul>
              </article>

              <article className="cvCard cvFeature">
                <h3 className="cvH3">Datos, reporting y control</h3>
                <p className="cvP">
                  SQL Server avanzado y reporting para dar visibilidad: métricas, Power BI y trazabilidad.
                </p>
                <ul className="cvBullets">
                  <li>Modelado, SPs, optimización</li>
                  <li>Cuadros de mando</li>
                  <li>Gobierno y seguridad</li>
                </ul>
              </article>
            </div>
          </div>
        </section>

        {/* STACK */}
        <section className="cvSection">
          <div className="cvContainer">
            <div className="cvSectionHead">
              <h2 className="cvH2">Stack</h2>
              <p className="cvMuted">Tecnologías con las que trabajo habitualmente.</p>
            </div>

            <div className="cvChips">
              {stack.map((s) => (
                <span key={s} className="cvChip">
                  {s}
                </span>
              ))}
            </div>
          </div>
        </section>

        {/* EXPERIENCIA */}
        <section className="cvSection">
          <div className="cvContainer">
            <div className="cvSectionHead">
              <h2 className="cvH2">Experiencia</h2>
              <p className="cvMuted">Trayectoria y responsabilidades principales.</p>
            </div>

            <div className="cvCard cvJob">
              <div className="cvJobHead">
                <div>
                  <h3 className="cvH3">Responsable de IT y Desarrollo · WGM</h3>
                  <p className="cvMuted">01/2007 – Presente</p>
                </div>
                <div className="cvJobTags" aria-label="Áreas">
                  <span className="cvTag">Arquitectura</span>
                  <span className="cvTag">Operación</span>
                  <span className="cvTag">Integración</span>
                </div>
              </div>
              <ul className="cvBullets">
                <li>Arquitectura técnica y evolución de soluciones GMAO/CMMS (web enterprise).</li>
                <li>Integraciones corporativas (JSON/REST), automatización y procesos batch/real-time.</li>
                <li>Soporte y resolución de incidencias complejas en producción (rendimiento y estabilidad).</li>
                <li>Administración y despliegue en IIS/Azure VM.</li>
              </ul>
            </div>

            <div className="cvCard cvJob">
              <div className="cvJobHead">
                <div>
                  <h3 className="cvH3">Jefe de Turno · Inforsistem</h3>
                  <p className="cvMuted">01/1998 – 01/2007</p>
                </div>
                <div className="cvJobTags" aria-label="Clientes">
                  <span className="cvTag">La Caixa</span>
                  <span className="cvTag">Telefónica</span>
                  <span className="cvTag">Banco Sabadell</span>
                </div>
              </div>
              <ul className="cvBullets">
                <li>Coordinación de equipos y supervisión de producción documental masiva.</li>
                <li>Control de calidad, plazos y continuidad del servicio.</li>
                <li>Gestión operativa y reporte a clientes.</li>
              </ul>
            </div>
          </div>
        </section>

        {/* CTA FINAL */}
        <section className="cvSection cvSectionTight">
          <div className="cvContainer">
            <div className="cvCard cvCtaCard">
              <div>
                <h2 className="cvH2">¿Hablamos?</h2>
                <p className="cvP">
                  Disponible para proyectos/posiciones donde la fiabilidad, la entrega y la evolución de
                  plataformas sean clave.
                </p>
              </div>
              <div className="cvCtas">
                <a className="cvBtnPrimary" href="mailto:koeman1976@hotmail.com">
                  Contactar por email
                </a>
                <a className="cvBtnGhost" href="https://linkedin.com" target="_blank" rel="noreferrer">
                  Ver LinkedIn
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </Fragment>
  );
};

export default Main;
